import { TextField, TextFieldProps } from '@mui/material';
import React from 'react';

const NoBorderTextField: React.FC<TextFieldProps> = (props) => {
    return (
        <TextField
            variant="standard"
            fullWidth
            {...props}
            InputProps={{
                disableUnderline: true,
                ...props.InputProps,
                sx: {
                    fontSize: 13,
                    padding: '2px 4px',
                    backgroundColor: 'transparent',
                    ...props.InputProps?.sx,
                },
            }}
            sx={{
                '& .MuiInputBase-root': {
                    padding: 0,
                },
                '& input': {
                    padding: '4px 6px',
                },
            }}
        />
    );
};

export default NoBorderTextField;